export default class MascaraHelper {
  static mostrarErro(mensagem) {
    window.ExibirMensagem(mensagem, window.TipoDeMensagem.Erro);
  }

  static mostrarSucesso(mensagem) {
    window.ExibirMensagem(mensagem, window.TipoDeMensagem.Sucesso);
  }
  static mostrarLoading() {
      const mensagem =
          "<img class='loader' src=\"/administracao/Content/images/loader.gif\" alt=\"Imagem de aguardando carregar tela\"  aria-label='Carregando conteudo'  role='alert'/> <h1>Por favor aguarde...</h1>";
      window.$.blockUI({ message: mensagem });
  }

  static esconderLoading() {
    window.$.unblockUI();
  }
}
